export default __webpack_public_path__ + "static/media/meetups-thumb-03.c4f32205.jpg";